import { clickform } from '~/constants';

export const redirectToClickform = () => {
  location.href = clickform;
};
